import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const steps = [
  {
    title: 'Você envia o histórico',
    description:
      'Vendas, estoque e compras, exportados do seu sistema em CSV ou Excel.',
  },
  {
    title: 'Validamos os dados',
    description:
      'Avaliamos a qualidade do histórico e apontamos inconsistências a corrigir.',
  },
  {
    title: 'Projetamos a demanda',
    description:
      'Estimamos a demanda por produto e comparamos com o seu método atual.',
  },
  {
    title: 'Você recebe a lista',
    description:
      'Lista priorizada de risco, excesso e quanto comprar de cada produto.',
  },
];

export default function HowItWorksSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="como-funciona" className="py-20 md:py-28 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-6" ref={ref}>
        <div className="text-center mb-14">
          <span className="inline-block font-sora font-semibold text-emerald-600 text-sm uppercase tracking-widest mb-3">
            Como funciona
          </span>
          <h2 className="font-sora font-bold text-3xl md:text-4xl text-zinc-900 mb-4">
            Do seu histórico à decisão de compra
          </h2>
          <p className="font-inter text-zinc-500 max-w-xl mx-auto text-base">
            Um processo direto, sem integração de sistema e sem mudança na sua rotina
            de compra.
          </p>
          <div className="w-12 h-1 bg-emerald-500 rounded-full mx-auto mt-5" />
        </div>

        <ol
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {steps.map((step, index) => (
            <li key={step.title}>
              <div className="flex items-center gap-4 mb-5">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-full bg-emerald-500 text-white font-sora font-bold">
                  {index + 1}
                </span>
                <span className="h-px bg-zinc-200 flex-1" aria-hidden="true" />
              </div>
              <h3 className="font-sora font-semibold text-base text-zinc-900 mb-2">
                {step.title}
              </h3>
              <p className="font-inter text-zinc-500 text-sm leading-relaxed">
                {step.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
